const cart = []

const handleCart = (state=cart, action) =>{
    const product = action.payload
    
    console.log(state);

    switch(action.type){
        case "ADDITEM":
            // Check if product already in cart
            const exist = state.find((x) => x.ProductID === product.ProductID)
            if(exist){
                // Increase the quantity
                return state.map((x)=>x.ProductID ===product.ProductID?{...x, qty: x.qty+1}:x)
            }
            else{
                return [...state, {...product, qty:1}]
            }
            break;
        case "DELITEM":
            const exist2 = state.find((x) => x.ProductID === product.ProductID)
            if(exist2.qty === 1){
                return state.filter((x)=>x.ProductID!==exist2.ProductID)
            }
            else{
                return state.map((x)=> x.ProductID===product.ProductID?{...x, qty:x.qty-1}:x)
            }
            break;
        case "CLEAR":
            return {...state, product:[]}
            break;
        default:
            return state
            break;
    }
    
}

export default handleCart